/** Desktop side panel width bounds (px). */
export const SIDE_PANEL_WIDTH_MIN = 280;
export const SIDE_PANEL_WIDTH_MAX = 560;
export const SIDE_PANEL_WIDTH_DEFAULT = 320;
export const SIDE_PANEL_WIDTH_STORAGE_KEY = "orymia-side-panel-width";

/** Clamp a raw width to the designer-panel range and round to a pixel. */
export function clampSidePanelWidth(width: number): number {
  if (!Number.isFinite(width)) return SIDE_PANEL_WIDTH_DEFAULT;
  return Math.min(
    SIDE_PANEL_WIDTH_MAX,
    Math.max(SIDE_PANEL_WIDTH_MIN, Math.round(width)),
  );
}

/** Read the last chosen panel width, falling back to the default. */
export function readStoredSidePanelWidth(): number {
  try {
    const raw = localStorage.getItem(SIDE_PANEL_WIDTH_STORAGE_KEY);
    if (raw == null || raw === "") return SIDE_PANEL_WIDTH_DEFAULT;
    return clampSidePanelWidth(Number(raw));
  } catch {
    return SIDE_PANEL_WIDTH_DEFAULT;
  }
}

/** Persist a clamped panel width. No-op if storage is unavailable. */
export function persistSidePanelWidth(width: number): void {
  try {
    localStorage.setItem(
      SIDE_PANEL_WIDTH_STORAGE_KEY,
      String(clampSidePanelWidth(width)),
    );
  } catch {
    // localStorage may be unavailable
  }
}
